export enum Role {
  Admin = "admin",
  Responsible = "responsible",
  Quality = "quality",
  References = "references",
  Production = "production",
  Worker = "worker",
  Maintenance = "maintenance",
}
